import { fromJS, List } from 'immutable';

export function request(state, { collection }) {
    return state.setIn(
        [ 'collections', collection, 'status' ],
        'IN_PROGRESS'
    );
}

export function finish(state, { collection, staff }) {
    let newUsers = {};

    staff.forEach(user => {
        newUsers[user.id] = user;
    });

    return state.updateIn(
        [ 'items' ], oldUsers => oldUsers.merge(newUsers)
    ).setIn(
        [ 'collections', collection, 'items' ],
        List(Object.keys(newUsers))
    ).setIn(
        [ 'collections', collection, 'status' ],
        'FINISHED'
    );
}

export function error(state, { collection, errors }) {
    return state.setIn(
        [ 'collections', collection, 'status' ],
        'ERROR'
    ).setIn([ 'collections', collection, 'errors' ], fromJS(errors));
}
